import { Component, Host, h, Prop, Listen, State, Watch } from '@stencil/core';

@Component({
  tag: 'ui-cms-algolia-search-field',
  styleUrl: 'ui-cms-algolia-search-field.scss',
})
export class UiCmsAlgoliaSearchField {
  @Prop({ mutable: true }) algoliaSearchTargetUrl: string;

  @Prop({ mutable: true }) i18n = { search: 'Suche' };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityI18n')
  utilityI18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  @Listen('sd-input') onChange(e) {
    this.searchValue = e.target.value;
  }

  @Listen('sd-search') onSearch() {
    if (this.searchValue?.length) {
      this.fireSearch();
      this.sendTrackingRequest();
    }
  }

  @State()
  searchValue: string;

  componentWillLoad() {
    this.utilityI18nChangeHandler(this.utilityI18n);
  }

  private handleInputKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter' && this.searchValue?.length) {
      this.fireSearch();
      this.sendTrackingRequest();
    }
  }

  private fireSearch() {
    const isNotSearchPage = this.algoliaSearchTargetUrl.startsWith('/');
    const finalUrl = new URL(
      isNotSearchPage ? `${window.location.origin}${this.algoliaSearchTargetUrl}` : window.location.href
    );
    finalUrl.searchParams.set('query', this.searchValue);

    window.open(finalUrl, '_self');
  }

  private sendTrackingRequest() {
    window.ui.services?.tracking?.track({
      attributes: {
        elementType: 'Link',
        elementLabel: this.searchValue,
        target: window.location.href,
      },
      eventInfo: {
        eventName: 'Search triggered',
        eventType: 'Action',
      },
      category: {
        area: 'Header',
      },
    });
  }

  render() {
    return (
      <Host>
        <sd-input
          placeholder={this.i18n.search}
          type="search"
          onKeyDown={this.handleInputKeyDown.bind(this)}
        ></sd-input>
      </Host>
    );
  }
}
